import MiniSearch from 'minisearch';

interface ScrapeData {
  author: string[];
  copyright: string | null;
  date: string | null;
  image: string | null;
  lang: string | null;
  links: ScrapeLinkData[];
  publisher: string | null;
  softTitle: string;
  tags: string[];
  text: string;
  videos: string[];
}

interface ScrapeLinkData {
  text: string;
  href: string;
}

let cache: any[] = [];
let index = 0;

const htmlTagRegex = /(<([^>]+)>)/gi;
const cleanHtml = (str) => str.replace(htmlTagRegex, '');

const urls = [
  `${process.env.CLIENT_SERVER_URL}/vida`,
  `${process.env.CLIENT_SERVER_URL}/vida/computer-requirements`,
  `${process.env.CLIENT_SERVER_URL}/vida/purchase`,
  `${process.env.CLIENT_SERVER_URL}/vehicle-emergency-response`,
  `${process.env.CLIENT_SERVER_URL}/new-users`,
  `${process.env.CLIENT_SERVER_URL}/wholesale-parts-hub/parts-overview`,
  `${process.env.CLIENT_SERVER_URL}/wholesale-parts-hub/parts-ordering`,
  `${process.env.CLIENT_SERVER_URL}/wholesale-parts-hub/certified-collision`,
];

const getScrapedData = async () => {
  cache = [];

  for (const url of urls) {
    const data: ScrapeData = await fetch(
      `${process.env.CLIENT_SERVER_URL}/api/scrape?q=${encodeURIComponent(url)}`
    ).then((res) => res.json());
    const newCacheData = data.links.map((s) => {
      return {
        id: index++,
        title: cleanHtml(s.text).trim(),
        url: s.href,
      };
    });
    cache = [...cache, ...newCacheData];
  }

  return cache;
};

let miniSearch = new MiniSearch({
  fields: ['title'],
  storeFields: ['title', 'url'],
  searchOptions: {
    boost: {
      title: 2,
    },
    fuzzy: 0.2,
  },
});

getScrapedData().then((c) => miniSearch.addAll(c));

export default miniSearch;
